var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"spinner"}),_c('h4',{staticClass:"mt-8 white--text"},[_vm._v("در حال انتقال به درگاه...")])])])
}]

export { render, staticRenderFns }